import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** *********************  START GET LOAN DISBURSEMENT REPORT DETAILS  ******************** */
export const LoanDisbursementListGet = (listData: any) => {
	const data = {
		LoanDisbursementReportToken: listData,
	};
	const url = `${API_URL}PostLoanDisbursementReport`;
	return makeApiCall(url, data);
};
/** *********************  END GET LOAN DISBURSEMENT REPORT LIST ******************** */

/** *********************  START GET OFFICER BASED ON BRANCH DETAILS  ******************** */
export const officerBranchListGet = (listData: any) => {
	const data = {
		GetOfficerListBranchToken: listData,
	};
	const url = `${API_URL}GetAllOfficerUserBasedonBranch`;
	return makeApiCall(url, data);
};
/** *********************  END GET OFFICER BASED ON BRANCH LIST ******************** */

/** *********************  START FETCH ALL PRODUCT TYPE LIST  ******************** */
export const allEconomicActivityFetch = (fetchBranchesData: any) => {
	const data = {
		FetchAllEconomicActivityTypeListDataToken: fetchBranchesData,
	};
	const url = `${API_URL}fetchAllEconomicActivityTypeList`;
	return makeApiCall(url, data);
};
/** *********************  END FETCH ALL PRODUCT TYPE LIST ******************** */
